import { useContext, useMemo } from 'react';
import { SessionContext } from '../../context/SessionContext';
import { Question } from '../../services/chat/getSessions.service';
import { useGetSessions } from './useGetSessions';

interface CurrentSession {
  isLoading: boolean;
  sessionId: string;
  lastSeqId: number;
  history: Question[];
  refetch: () => void;
}

export const useCurrentSession = (): CurrentSession => {
  const { sessionInfo } = useContext(SessionContext);
  const { sessionId } = sessionInfo;
  const { data, refetch, isFetching } = useGetSessions();

  const history = useMemo(
    () => data?.find((item) => item.session_id === sessionId)?.session_history ?? [],
    [data, sessionId]
  );

  const lastSeqId = useMemo(() => Math.max(0, ...history.map((item) => item.query_seq_id)), [history]);

  return {
    isLoading: isFetching,
    sessionId,
    history,
    lastSeqId,
    refetch,
  };
};
